export default __webpack_public_path__ + "static/rsz_logo_z_govtechem-02_1_1-b2c79f7489da50b1f20e1efc7fbcd0f1.jpg";